/**
 * /eric/waitlist — Waitlist queue (T-051, PR-05).
 *
 * Route config only. Component lives in eric.waitlist.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/waitlist')({});
